module.exports = __webpack_public_path__ + "img/1440.115ed2ed.jpg";